import { faThumbsUp } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { useCallback } from 'react';
import { ContentTaskFilteringGq } from '../../../graphql/projects/models/ContentTaskFilteringGq';
import { ContentTaskStatusGq } from '../../../graphql/projects/models/ContentTaskStatusGq';
import { projectsApiService } from '../../../graphql/projects/projectsApiService';
import { ApprovedIcon } from '../../../pages/ContentPlanPage/Components/Tables/ContentTaskTable/TaskApproved';
import VoxelButton from '../../voxel/Buttons/VoxelButton';
import { VoxelPopover } from '../../voxel/Popover/VoxelPopover';
import { VoxelPopoverContent } from '../../voxel/Popover/VoxelPopoverContent';
import { VoxelPopoverTrigger } from '../../voxel/Popover/VoxelPopoverTrigger';
import VoxelMenuItemContainer from '../../voxel/PopoverMenu/VoxelMenuItemContainer';
import VoxelPopoverMenuItem from '../../voxel/PopoverMenu/VoxelPopoverMenuItem';
import VoxelText from '../../voxel/Text/VoxelText';

export interface ApproveAllContentPlanPopoverProps {
  filteringState: ContentTaskFilteringGq;
  reload: () => Promise<any>;
}

const ApproveAllContentPlanPopover: React.FC<ApproveAllContentPlanPopoverProps> = ({
  filteringState,
  reload,
}) => {
  const approvedList = Object.values(ContentTaskStatusGq).map((a) => ({
    approved: a,
  }));

  // Popover logic

  const approveContentTasksMutation =
    projectsApiService.mutations.contentPlan.useApproveContentTasks();

  const handleApproveContentTasks = useCallback(
    (approved: ContentTaskStatusGq) => {
      approveContentTasksMutation({
        contentTaskFiltering: filteringState,
        approvedStatus: approved,
      }).then(reload);
    },
    [reload, filteringState]
  );

  return (
    <VoxelPopover>
      <VoxelPopoverTrigger enableActive>
        <VoxelButton
          tooltip="Set status on filtered urls"
          size="md"
          title="Set status"
          color="light-gray"
          endIcon={<FontAwesomeIcon icon={faThumbsUp} />}
          tooltipProps={{ placement: 'top' }}
        />
      </VoxelPopoverTrigger>
      <VoxelPopoverContent className="overflow-x-hidden">
        <div className="w-fit">
          <div className="px-4 pt-2 pb-2 border-b border-gray-200 bg-gray-100">
            <VoxelText noWrap>Set on currently filtered URLs</VoxelText>
          </div>
          <VoxelMenuItemContainer>
            {approvedList.map((a, index) => (
              <VoxelPopoverMenuItem
                key={index}
                title={a.approved}
                onClick={() => handleApproveContentTasks(a.approved)}
                icon={<ApprovedIcon status={a.approved} size={'small'} />}
              />
            ))}
          </VoxelMenuItemContainer>
        </div>
      </VoxelPopoverContent>
    </VoxelPopover>
  );
};

export default ApproveAllContentPlanPopover;
